export default __webpack_public_path__ + "static/media/wordwell-logo.5e5e828b.png";